import {
  Body,
  Controller,
  Post,
  Req,
  UploadedFiles,
  UseInterceptors,
} from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import {
  AllVehicleIssueResponseModel,
  CommonResponseModel,
  departmentIdReq,
  driverIdReq,
  VehicleIssueData,
} from "@project-management-system/shared-models";
import { ApplicationExceptionHandler } from "packages/libs/backend-utils/src/";
import { VehicleIssueService } from "./vehicle-issue-service";
import { VehicleIssueDto } from "./vehicle-issue-dto";
import { FilesInterceptor } from "@nestjs/platform-express";
import { diskStorage } from "multer";

@ApiTags("/vehicleissue")
@Controller("vehicleissue")
export class VehicleIssueController {
  constructor(
    private readonly vehicleissueService: VehicleIssueService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }
  @ApiBody({ type: VehicleIssueDto })
  @Post("/createVehicleIssue")
  async createVehicleIssue(
    @Body() dto: any,
    isUpdate: boolean = false
  ): Promise<AllVehicleIssueResponseModel> {
    try {
      return await this.vehicleissueService.createVehicleIssue(dto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        AllVehicleIssueResponseModel,
        error
      );
    }
  }

  @Post("/updateVehicleIssue")
  async updateVehicleIssue(
    @Body() dto: any,
    @Req() request: Request
  ): Promise<AllVehicleIssueResponseModel> {
    try {
      return await this.vehicleissueService.createVehicleIssue(dto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        AllVehicleIssueResponseModel,
        error
      );
    }
  }

  @Post("/getEmployee")
  async getEmployee(): Promise<CommonResponseModel> {
    try {
      return await this.vehicleissueService.getEmployee();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/vehicleIssuefileUpload")
  @UseInterceptors(
    FilesInterceptor("file", 10, {
      storage: diskStorage({
        destination: "./upload_files",
        filename: (req, file, callback) => {
          // console.log(file.originalname);
          const name = file.originalname;
          callback(null, `${name}`);
        },
      }),
      fileFilter: (req, file, callback) => {
        if (!file.originalname.match(/\.(jpeg|png)$/)) {
          return callback(new Error("Only pdf,PDF files are allowed!"), false);
        }
        callback(null, true);
      },
    })
  )
  async vehicleIssuefileUpload(
    @UploadedFiles() file: File[],
    @Body() uploadData: any,
    vehicleIssueId: number
  ): Promise<any> {
    try {
      return await this.vehicleissueService.vehicleIssuefileUpload(
        file,
        uploadData.createdUser,
        uploadData.vehicleIssueId
      );
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getVehicle")
  async getVehicle(): Promise<CommonResponseModel> {
    try {
      return await this.vehicleissueService.getVehicle();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getAllVehicleissue")
  @ApiBody({ type: driverIdReq })
  async getAllVehicleissue(@Body() req:any): Promise<CommonResponseModel> {
    try {
      return await this.vehicleissueService.getAllVehicleissue(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        err
      );
    }
  }
  @Post("/getVehicleIssueDashBoard")
  async getVehicleIssueDashBoard(): Promise<CommonResponseModel> {
    try {
      return await this.vehicleissueService.getVehicleIssueDashBoard();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  
}
